import { render } from "./NotView.vue?vue&type=template&id=df6a4628&scoped=true"
const script = {}

import "./NotView.vue?vue&type=style&index=0&id=df6a4628&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6a4628"]])

export default __exports__